module.exports = __webpack_public_path__ + "img/text-effect-shadow.ecde8ee0.png";